import React, { FC } from "react";
import classNames from "classnames";
import CountDown from "@/components/CountDown";
import { useTranslations } from "next-intl";
import { I18N_NAMESPACE } from "@/config/i18n";

interface Props {
  timerContainerClassName?: string;
  timerClassName?: string;
  endTime: string;
  labelClassName?: string;
  className?: string;
  isUnstarted?: boolean;
}
const Timer: FC<Props> = ({
  timerContainerClassName = "",
  timerClassName = "",
  endTime,
  labelClassName = "",
  className = "",
  isUnstarted = false,
}) => {
  const t = useTranslations(I18N_NAMESPACE.PROMOTIONS);

  return (
    <div
      className={classNames(
        "flex flex-col items-center justify-center text-center rounded",
        className
      )}
    >
      <h4
        className={classNames(
          "mb-2 text-xs font-normal leading-3 md:leading-[14px] md:text-sm text-tertiary dark:text-white text-center",
          labelClassName
        )}
      >
        {isUnstarted ? t("starts-in") : t("time-remaining")}
      </h4>
      <div
        className={classNames(
          "flex justify-center gap-1",
          timerContainerClassName
        )}
      >
        <CountDown
          endTime={endTime}
          className={classNames(
            "w-[54px] gap-2 md:gap-1 md:w-16 flex flex-col py-2 text-center border rounded border-tertiary-50 dark:border-tertiary-300 ",
            timerClassName
          )}
          labelClassName="text-[8px] leading-[8px] text-tertiary font-bold opacity-50 dark:text-white/70"
          valueClassName="text-base font-bold leading-4 text-tertiary md:leading-5 md:text-xl dark:text-white"
        />
      </div>
    </div>
  );
};

export default Timer;
